export const IMAGE_KIT_ENDPOINT_URL = "https://ik.imagekit.io/srjnqnjbpn9/";
